'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bulk = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _BaseAction2 = require('./BaseAction');

var _BaseAction3 = _interopRequireDefault(_BaseAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var uuidv1 = require('uuid/v1');

/**
 * Class representing a bulk action.
 * @extends BaseAction
 */

var Bulk = exports.Bulk = function (_BaseAction) {
  _inherits(Bulk, _BaseAction);

  /**
   * Create an instance of the bulk action.
   * @param {Object} config - The configuration for the action.
   */
  function Bulk(config) {
    _classCallCheck(this, Bulk);

    var _this = _possibleConstructorReturn(this, (Bulk.__proto__ || Object.getPrototypeOf(Bulk)).call(this, 'bulk', config));

    _this.do = function (instance, record) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$config = _this.config,
          uidField = _this$config.uidField,
          bulker = _this$config.bulker,
          actionSettings = _this$config.actionSettings,
          api = _this$config.api,
          notificationActions = _this$config.notificationActions,
          normalizationSettings = _this$config.normalizationSettings;

      //console.log('actionSettings', actionSettings);
      //console.log('api', api);
      //console.log('notificationAction', notificationAction);

      // Extend fetch options

      options = _extends({}, _this.defaultOptions, options);

      // Make sure record is an immutable map
      record = _immutable2.default.Iterable.isIterable(record) ? record : _immutable2.default.fromJS(record);

      // Validate instance key
      _this.validateInstance(instance);

      if (_immutable.List.isList(record)) {
        // ADD uids to new items
        record = record.map(function (item) {
          return item.get(uidField) === undefined ? item.get('tmpid') === undefined ? item.set('tmpid', uuidv1()) : item : item;
        });
      } else {
        if (record.get(uidField) === undefined && record.get('tmpid') === undefined) {
          record = record.set('tmpid', uuidv1());
        }
      }

      return function (dispatch) {
        // Create data object to be dispatched with actions
        var isAsync = options.isAsync !== undefined ? options.isAsync : typeof bulker === 'function' || actionSettings !== undefined;
        var data = { instance: instance, record: record, uidField: uidField, isAsync: isAsync, options: options, normalizationSettings: normalizationSettings };
        var msguid = uuidv1();

        // Call BaseAction.start with dispatch and the action data
        _this.start(dispatch, data);

        //console.log('action bulk:', data.isAsync);

        if (actionSettings !== undefined && isAsync) {
          var notify = notificationActions.notify,
              notifyDismiss = notificationActions.notifyDismiss;
          // Extend config options

          var settings = _extends({}, actionSettings.default, actionSettings.bulker);
          //console.log(settings);
          var displayLoading = settings.loading !== undefined && settings.loading !== '' ? true : false;
          var displayNotification = settings.notification !== undefined && settings.notification.type === 'notification' ? true : false;
          var displayMessage = settings.notification !== undefined && !displayNotification ? true : false;

          if (displayLoading) {
            dispatch(notify({
              id: msguid,
              title: settings.loading !== undefined ? settings.loading : 'Please wait',
              kind: 'loading'
            }));
          }

          //console.log('auto bulker action');
          var successHandler = _this.success.bind(_this, dispatch, data);
          var errorHandler = _this.error.bind(_this, dispatch, data);

          var url = settings.url;

          var activeProperty = localStorage.activeProperty !== undefined && localStorage.activeProperty !== 'undefined' ? JSON.parse(localStorage.activeProperty) : null;
          var propertycode = activeProperty !== null ? activeProperty.propertycode : null;

          if (options && options.property_id) {
            var properties = localStorage.properties !== undefined && localStorage.properties !== 'undefined' ? JSON.parse(localStorage.properties) : [];
            var overrideProperty = properties.find(function (property) {
              return property.id === options.property_id;
            });
            if (overrideProperty && overrideProperty.propertycode) {
              propertycode = overrideProperty.propertycode;
            }
          }

          if (propertycode !== null) {
            url = settings.url.replace(/#@propertycode@#/i, propertycode);
          }

          if (options.url) {
            url = url + '/' + options.url;
          }

          return api.patch(url, record.toJSON()).then(function (response) {
            if (displayLoading) {
              dispatch(notifyDismiss(msguid));
            }

            var message = '';

            if (response.data.success) {
              successHandler(response.data.data || [], null, response.data.updates || []);
              message = response.data.message;

              if (displayNotification) {
                dispatch(notify({
                  title: settings.notification.title,
                  message: settings.notification.message !== undefined ? settings.notification.message : message,
                  type: 'notification',
                  kind: settings.notification.kind !== undefined ? settings.notification.kind : 'success'
                }));
              } else if (displayMessage) {
                dispatch(notify({
                  title: settings.notification.title !== undefined ? settings.notification.title : message, //response.data.message,
                  kind: settings.notification.kind !== undefined ? settings.notification.kind : 'success'
                }));
              }
            } else {
              errorHandler(response.data.error);
              message = response.data.error.message !== undefined ? response.data.error.message : response.data.error;

              dispatch(notify({
                title: settings.error.title,
                message: message || settings.error.message,
                type: 'notification',
                kind: settings.error.kind !== undefined ? settings.error.kind : 'error'
              }));
            }
            return response.data;
          }).catch(function (error) {
            if (displayLoading) {
              dispatch(notifyDismiss(msguid));
            }
            errorHandler(error);

            if (error && error.response && error.response.status && error.response.status !== 401) {

              if (settings.error.type !== undefined && settings.error.type === 'notification') {
                dispatch(notify({
                  title: settings.error.title,
                  message: settings.error.message !== undefined ? settings.error.message : error.response.data.message,
                  type: 'notification',
                  kind: settings.error.kind !== undefined ? settings.error.kind : 'error'
                }));
              } else {
                dispatch(notify({
                  title: settings.error.title !== undefined ? settings.error.title : error.response.data.message,
                  kind: settings.error.kind !== undefined ? settings.error.kind : 'error'
                }));
              }
            }
          });
        } else {
          // If config.bulker is provided, call it
          //if(!isAsync) {

          // Prepare BaseAction.success and BaseAction.error handlers
          // by currying with dispatch
          var success = _this.success.bind(_this, dispatch, data);
          /*const error = */_this.error.bind(_this, dispatch, data);
          return success(record || []);
          // Call bulker
          //return bulker(record, success, error);
          //}
        }
      };
    };

    return _this;
  }

  /**
   * Default options for the fetch action.
   */


  /**
   * Generate an action creator with the provided data.
   * @param {Object} record - item being updated.
   *
   * @returns {Function} - Returns the bulk action thunk.
   */


  return Bulk;
}(_BaseAction3.default);

Bulk.defaultOptions = {
  appendResponse: true,
  normalizeResponse: false,
  property_id: null };